import React from 'react'

import { Container } from 'components/Layout'

import cn from 'classnames'
import s from './HeadingBanner.scss'

export default props => {
  const { children, className, position, filled } = props
  return (
    <div className={cn(s.root, className, { [s.filled]: filled })}>
      <Container className={s.inner} style={{ opacity: `${1 - position / 200}` }}>
        {children}
      </Container>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Text/HeadingBanner/HeadingBanner.jsx